import { useQuery } from '@tanstack/react-query';

import { billingApi } from './api/billing.api';

export const billingKeys = { entitlements: ['billing', 'entitlements'] as const };

/** The backend is the authority; this only shapes the UI. Refreshed every few minutes and on focus. */
export function useEntitlements() {
  return useQuery({ queryKey: billingKeys.entitlements, queryFn: billingApi.entitlements, staleTime: 60_000 });
}
